import { Outlet } from 'react-router-dom'
import { TabBar } from './TabBar'

/**
 * The persistent frame every tabbed surface renders inside — the web analog of the app's `TabView`
 * (`Shutter Up/ShutterUp/App/ContentView.swift:31-70`).
 *
 * The shell owns the frame and the bar; it deliberately does NOT constrain content width. The
 * download card wants a 400px column, the Library grid wants the full viewport, so that cap belongs
 * to each route rather than here. The background is not the shell's either — it sits on `body`
 * (`index.css`), so surfaces rendered outside the shell stay legible.
 *
 * Sign-in gating is also not the shell's job: the downloader is usable signed out, and the tabs that
 * need a session prompt for one themselves.
 */
export function AppShell() {
  return (
    <div className="min-h-screen">
      {/* Reserves the fixed bar's height plus the home-indicator inset, so the last element of any
          route stays reachable instead of sitting underneath the bar. */}
      <main className="pb-[calc(3.5rem+env(safe-area-inset-bottom))]">
        <Outlet />
      </main>
      <TabBar />
    </div>
  )
}
